import React from 'react';
import { FiRotateCcw } from 'react-icons/fi';

function PromptEditor({ value, onChange, onReset }) {
  return (
    <div className="prompt-editor">
      <div className="field-heading">
        <label htmlFor="system-prompt">System prompt</label>
        <button className="ghost-button" onClick={onReset} type="button">
          <FiRotateCcw /> Reset
        </button>
      </div>
      <textarea
        className="mono-input"
        id="system-prompt"
        onChange={(event) => onChange(event.target.value)}
        rows={8}
        value={value}
      />
      <span className="field-hint">{value.length} characters</span>
    </div>
  );
}

export default PromptEditor;
